document.addEventListener("DOMContentLoaded", () => {
  // Constructor function for the StockistMap object
  function StockistMap() {
    this.searchBox = document.getElementById("stockist-search");
    this.map = document.getElementById("stockist-map");
    if (this.map) {
      this.endpoint = this.map.getAttribute("src");
    }
    this.stockistType = 5; // Could be made configurable
    this.debounceTimeout = null;

    if (this.endpoint) {
      this.init();
    }
  }

  // Initialize the StockistMap instance
  StockistMap.prototype.init = function () {
    this.bindInputEvent();
  };

  // Bind the input event handler to the search box
  StockistMap.prototype.bindInputEvent = function () {
    this.searchBox.addEventListener("input", () => {
      clearTimeout(this.debounceTimeout); // Clear any previous timeouts

      this.debounceTimeout = setTimeout(() => {
        this.updateMapEndpoint(this.searchBox.value + ", Europe");
      }, 600); // Adjust delay (in ms) as needed
    });
  };

  // Update the map's source URL with the new search query
  StockistMap.prototype.updateMapEndpoint = function (searchQuery) {
    const queryParams = {
      search: searchQuery,
      "filter[stockist-types]": `[${this.stockistType}]`,
    };

    const queryString = Object.entries(queryParams)
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");

    this.map.src = `${this.endpoint}?${queryString}`;
  };

  // Initialize the StockistMap
  new StockistMap();
});
